<!-- 小窗口 -->

<template>
  <div class="tool">
    <!-- <div class="minimap-button" @click="handleToggle">
      {{ minimapVisible ? "⬆" : "⬇" }}
    </div> -->
    <div ref="minimap" class="minimap-container">
      <div id="minimap" class="minimap"></div>
    </div>
    <node-search
      class="node-search-tool"
      placement="top"
      :graph="graph"
      :node-list="nodeList"
      @select="handlerSelectNode"
    />
    <div class="zoom-tool">
      <!-- <button class="button" :disabled="zoom <= 10" @click="zoomOut">➖</button>
      <div class="zoom">{{ zoom }}%</div>
      <button class="button" :disabled="zoom >= 200" @click="zoomIn">➕</button> -->
      <div class="input-number-wrapper">
        <t-button
          variant="text"
          style="padding-right: 0px; padding-left: 10px"
          @click="handlerRoomChange(false)"
        >
          <template #icon>
            <img :src="Minus" alt="center" class="tool-icon" />
          </template>
        </t-button>
        <span class="vertical-line"></span>
        <div class="value">{{ zoom }}%</div>
        <span class="vertical-line"></span>
        <t-button variant="text" @click="handlerRoomChange(true)">
          <template #icon>
            <img :src="Plus" alt="center" class="tool-icon" />
          </template>
        </t-button>
      </div>
      <!-- <t-input-number
        :step="10"
        :value="zoom"
        :max="200"
        :min="20"
        align="right"
        suffix="%"
        @change="handlerRoomChange"
      /> -->
      <!-- <t-button shape="square" variant="text" @click="zoomReset">
        <template #icon><ArtboardIcon /></template>
      </t-button>
      <t-button shape="square" variant="text" @click="handleClickLayout(true)">
        <template #icon><GestureApplauseIcon /></template>
      </t-button> -->
      <div class="operation-wrapper">
        <t-button variant="text" class="tool-border" @click="centerGraph">
          <template #icon
            ><img :src="CenterFocusIcon" alt="center" class="tool-icon"
          /></template>
          {{ $t("回到中心") }}
        </t-button>
        <t-button
          variant="text"
          class="tool-border"
          @click="handleClickLayout(true)"
        >
          <template #icon
            ><img :src="AutoAdjust" alt="adjust" class="tool-icon"
          /></template>
          {{ $t("自动对齐") }}
        </t-button>
      </div>
      <!-- <t-button shape="square" variant="text" @click="handlerSave">
        <template #icon><SaveIcon /></template>
      </t-button> -->

      <!-- <button class="button" @click="focusStart(NODE_TYPE.startNode.id)">🔘</button> -->
    </div>
  </div>
</template>

<script>
import { debounce, max, min, ceil } from "lodash-es";
import {
  // CenterFocusStrongIcon,
  ArtboardIcon,
  SaveIcon,
  GestureApplauseIcon,
} from "tdesign-icons-vue-next";
import CenterFocusIcon from "./centerFocus.svg";
import Plus from "./plus.svg";
import Minus from "./minus.svg";
import AutoAdjust from "./autoAdjust.svg";
import NodeSearch from "../node-search/index.vue";
export default {
  name: "CanvasZoom",
  components: {
    NodeSearch,
    // ArtboardIcon,
    // SaveIcon,
    // GestureApplauseIcon,
  },
  props: {
    graph: {
      type: Object,
      default: null,
    },
    nodeList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["handlerSave", "handleClickLayout", "centerGraph", "selectNode"],
  data() {
    return {
      zoom: 100,
      zoomRate: 10,
      initEd: false,
      minimapVisible: true, // 缩略图是否可见
      CenterFocusIcon,
      AutoAdjust,
      Plus,
      Minus,
    };
  },
  computed: {
    debounceFocusStart() {
      return debounce(this.focusStart, 650);
    },
  },
  watch: {
    graph() {
      this.init();
    },
    minimapVisible(v) {
      this.$refs.minimap.style.height = v ? "auto" : "0";
    },
  },
  mounted() {
    this.init();
  },
  unmounted() {
    this.destroy();
  },
  methods: {
    destroy() {
      this.graph.off("viewportchange", this.handlerViewportChange);
    },
    init() {
      if (this.graph) {
        this.initEd = true;
        this.zoom = Math.round(this.graph.getZoom() * 100);
        this.graph.on("viewportchange", this.handlerViewportChange);
      }
    },
    handlerViewportChange(e) {
      this.zoom = ceil(Math.round(this.graph.getZoom() * 100), 0);
    },
    handleToggle() {
      this.minimapVisible = !this.minimapVisible;
    },
    changeGraphZoom(value) {
      this.graph.zoomTo(value / 100, false, false);
    },
    handlerRoomChange(isPlus) {
      const step = 10;
      let zoom = this.zoom;
      zoom = isPlus ? min([zoom + step, 200]) : max([zoom - step, 20]);
      this.changeGraphZoom(zoom);
    },
    zoomReset() {
      this.changeGraphZoom(100);
      this.debounceFocusStart();
    },
    focusStart(id = "startNode") {
      const startNode = this.graph.findById(id);
      if (startNode) {
        this.graph.focusItem(startNode, false);
      }
    },
    handlerSave() {
      this.$emit("handlerSave");
    },
    handleClickLayout(v) {
      this.$emit("handleClickLayout", v);
    },
    centerGraph() {
      this.changeGraphZoom(100);
      this.$emit("centerGraph");
    },
    handlerSelectNode(nodeId) {
      this.$emit("selectNode", nodeId);
    },
  },
};
</script>

<style lang="less" scoped>
.tool {
  position: absolute;
  bottom: 25px;
  right: 20px;
  // left: 20px;
  padding: 9px 11px;
  user-select: none;
  box-shadow:
    0px 4px 10px rgba(32, 77, 141, 0.04),
    0px 1px 2px rgba(32, 77, 141, 0.04);
  border-radius: 16px;
  z-index: 100;
  background-color: #fff;
  // 节点查询的结果列表需要向上溢出工具栏展示
  overflow: visible;
  transition: all 0.2s ease-out;
  .node-search-tool {
    margin-bottom: 10px;
  }
  .zoom-tool {
    display: flex;
    :deep(.flow-t-button--variant-text) {
      padding-left: 0px;
      padding-right: 10px;
    }
    .operation-wrapper {
      .tool-border {
        &::before {
          content: "";
          margin-right: 10px;
          display: inline-block;
          height: 20px;
          border-right: 1px solid #e2eaf7;
        }
      }
      .tool-icon {
        margin-right: 6px;
      }
    }
  }
}
.minimap-container {
  overflow: hidden;
}
.input-number-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  .vertical-line {
    width: 1px;
    height: 20px;
    background-color: #e2eaf7;
  }
}
</style>
